import { IconHourglass, IconProgress, IconCheck } from "@tabler/icons-react";
import {
  UIStatuses,
  icons as statusIcons,
} from "../../OverviewStatuses/StatusConstants";
import type { StatusBadgeConfig } from "../types";

/**
 * Centralized organizer status configuration
 * Used across OrganizerStatusBadge and OrganizerStatusFilterChips
 */
export const ORGANIZER_STATUS_CONFIG = {
  "not started": {
    color: "#6c757d",
    text: "Not Started",
    textColor: "#ffffff",
    icon: <IconHourglass size={16} />,
  },
  "in progress": {
    color: "#5b7fcf",
    text: "In Progress",
    textColor: "#ffffff",
    icon: <IconProgress size={16} />,
  },
  complete: {
    color: "#16a34a",
    text: "Submitted",
    textColor: "#ffffff",
    icon: <IconCheck size={16} />,
  },
  submitted: {
    color: "#16a34a",
    text: "Submitted",
    textColor: "#ffffff",
    icon: <IconCheck size={16} />,
  },
} as const;

/**
 * Get status badge configuration with icon
 * :param status: The status string to get badge props for
 * :return: Badge configuration object with color, text, and icon
 */
export const getStatusBadgeProps = (status: string): StatusBadgeConfig => {
  const statusConfig = UIStatuses.find((s) => s.text === status);
  const statusIndex = UIStatuses.findIndex((s) => s.text === status);
  return {
    color: statusConfig?.color || "#6B7280",
    text: status || "New",
    icon: statusIndex >= 0 ? statusIcons[statusIndex] : null,
  };
};

/**
 * Get organizer status badge configuration with icon
 * :param organizerStatus: The organizer status string (nullable)
 * :return: Badge configuration object with color, text, and icon
 */
export const getOrganizerStatusBadgeProps = (
  organizerStatus: string | null
): StatusBadgeConfig => {
  const normalizedStatus = (organizerStatus || "Not Started").toLowerCase();
  const config =
    ORGANIZER_STATUS_CONFIG[
      normalizedStatus as keyof typeof ORGANIZER_STATUS_CONFIG
    ];

  return (
    config || {
      color: "#6c757d",
      text: "Not Started",
      icon: <IconHourglass size={16} />,
    }
  );
};
